// src/components/LogoutDialog.js
import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import "./logoutDialog.css";

class LogoutDialog extends Component {
  render() {
    const { show, onHide, onAppLogout, onFullLogout } = this.props;

    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Sign Out</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="logout-dialog-text">How would you like to sign out?</p>
          <div className="logout-options">
            <Button variant="outline-primary" className="logout-option-btn mb-3 w-100" onClick={onAppLogout}>
              <div className="logout-option-content">
                <strong>Sign out of TABS Portal only</strong>
                <br />
                <small className="text-muted">Stay signed in to your Microsoft account</small>
              </div>
            </Button>

            <Button variant="primary" className="logout-option-btn w-100" onClick={onFullLogout}>
              <div className="logout-option-content">
                <strong>Sign out completely</strong>
                <br />
                <small style={{ color: "rgba(255, 255, 255, 0.9)" }}>
                  Sign out of Microsoft account (recommended for shared computers)
                </small>
              </div>
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default LogoutDialog;
